var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIotWeightNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.967,
    height: 35,
    viewBox: "0 0 48.967 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-661.146 -448)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(661.646 450.779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.164,22.6q-2.265-8.9-4.645-17.772a1.116,1.116,0,0,0-1.054-.832c-.682-.014-3.621-.01-7.023,0a3.649,3.649,0,0,0,1.325-2.813h0A3.653,3.653,0,1,0,360.8,4.011c-3.039.013-5.823.026-7.139.033a1.05,1.05,0,0,0-1.007.778l-4.811,17.935a1.046,1.046,0,0,0,1.007,1.322c4.813,0,21.11.007,28.161,0a1.187,1.187,0,0,0,1.147-1.479ZM363.114-.573h0a1.755,1.755,0,0,1,1.753,1.752h0a1.754,1.754,0,1,1-1.753-1.754Z",
    transform: "translate(-347.811 2.473)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(686.113 448)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,5,5l5-5Z",
    transform: "translate(3.5 9)",
    fill: "#ffd500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,5,5l5-5Z",
    transform: "translate(20.5 15) rotate(180)",
    fill: "#ffd500"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-96.092)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(773 467)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 16,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 29,
    height: 15,
    rx: 3.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(779 479)",
    fill: "#7b7b7b",
    fontSize: 10,
    fontFamily: "SegoeUI, Segoe UI"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Net"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIotWeightNet);
export default __webpack_public_path__ + "static/media/iotWeightNet.ee826987984f68d615fb5e0986e7eaae.svg";
export { ForwardRef as ReactComponent };